import React, { useState } from 'react';
import { errorText, formatDate, parseApiDate } from './strengthFormat';

function StravaPanel({ api, t, lang, status, onStatusChanged, showMessage }) {
  const [busy, setBusy] = useState(false);

  const connect = async () => {
    setBusy(true);
    try {
      // Strava returns the athlete to this page; StrengthApp finishes the connection.
      const { url } = await api.stravaAuthorizeUrl(`${window.location.origin}/strength`);
      window.location.assign(url);
    } catch (e) {
      showMessage(errorText(e, t('strength.strava.connectFailed')), 'error');
      setBusy(false);
    }
  };

  const disconnect = async () => {
    if (!window.confirm(t('strength.strava.disconnectConfirm'))) return;
    setBusy(true);
    try {
      onStatusChanged(await api.stravaDisconnect());
      showMessage(t('strength.strava.disconnected'));
    } catch (e) {
      showMessage(errorText(e, t('strength.errors.save')), 'error');
    } finally {
      setBusy(false);
    }
  };

  if (!status) return <div className="st-empty">{t('strength.loading')}</div>;

  return (
    <div className="st-card st-strava-panel">
      <h2>{t('strength.strava.title')}</h2>

      {!status.configured ? (
        <p className="st-callout">{t('strength.strava.notConfigured')}</p>
      ) : status.connected ? (
        <>
          <p className="st-strava-connected">
            ✅ {t('strength.strava.connectedAs', { name: status.athleteName || 'Strava' })}
            {status.connectedAt && <span className="st-muted"> · {t('strength.strava.since', { date: formatDate(parseApiDate(status.connectedAt), lang, { day: 'numeric', month: 'long', year: 'numeric' }) })}</span>}
          </p>
          {status.pendingUploads > 0 && <p>🔄 {t('strength.strava.pending', { count: status.pendingUploads })}</p>}
          {status.failedUploads > 0 && <p className="st-error">{t('strength.strava.failed', { count: status.failedUploads })}</p>}
          <button type="button" className="st-btn st-btn-danger-ghost" disabled={busy} onClick={disconnect}>
            {t('strength.strava.disconnect')}
          </button>
        </>
      ) : (
        <>
          <p>{t('strength.strava.pitch')}</p>
          <button type="button" className="st-strava-connect" disabled={busy} onClick={connect}>
            {t('strength.strava.connect')}
          </button>
        </>
      )}

      <ul className="st-strava-facts">
        <li>{t('strength.strava.factUpload')}</li>
        <li>{t('strength.strava.factReadNothing')}</li>
        <li>{t('strength.strava.factPrivate')}</li>
        <li>{t('strength.strava.factDelete')}</li>
      </ul>
    </div>
  );
}

export default StravaPanel;
